<template>
  <div>
    <Head title="Traffic Sources" />
    <h1 class="mb-8 text-3xl font-bold">Traffic Sources</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
          <label class="block text-gray-700">Brand:</label>
          <select v-model="form.brand" class="form-select mt-1 w-full">
              <option :value="null">All brands</option>
              <option v-for="(id, name) in brands" :value="id" :key="id">{{name}}</option>
          </select>
      </search-filter>
      <Link class="btn-indigo" href="/traffic-sources/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Traffic source</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Is Default</th>
          <th class="pb-4 pt-6 px-6">Brand</th>
          <th class="pb-4 pt-6 px-6">Visitors</th>
          <th class="pb-4 pt-6 px-6" colspan="2">CreatedAt</th>
        </tr>
        <tr v-for="trafficSource in trafficSources" :key="trafficSource.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/traffic-sources/${trafficSource.id}/edit`" tabindex="-1">
              {{ trafficSource.name }}
            </Link>
          </td>
            <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/traffic-sources/${trafficSource.id}/edit`" tabindex="-1">
                    {{ trafficSource.is_default ? '✅' : '️' }}
                </Link>
            </td>
            <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/traffic-sources/${trafficSource.id}/edit`" tabindex="-1">
              {{ trafficSource.brand_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/traffic/${trafficSource.id}`" tabindex="-1">
              <span class="bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                View funnel ({{ trafficSource.visitors }})
              </span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/traffic-sources/${trafficSource.id}/edit`" tabindex="-1">
              {{ trafficSource.created_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/traffic-sources/${trafficSource.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="trafficSources.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No traffic sources found.</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from "@/Shared/SearchFilter";

export default {
  components: {
      SearchFilter,
    Head,
    Icon,
    Link,
    SearchInput,
  },
  layout: Layout,
  props: {
    filters: Object,
      trafficSources: Array,
      brands: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        brand: this.filters.brand,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/traffic-sources', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
